import React from 'react'
import { useState } from 'react';
import "./TextEdit.scss"
import Tilt from "react-parallax-tilt";
import tickIcon from "../../../Images/SVGs/circle-check-solid.svg";
import closeIcon from "../../../Images/SVGs/plus-solid.svg";
import { success, fail } from "../../Alerts/Alerts.js";
import axios from 'axios';
import env from "../../../config.json";


const authAxios = axios.create({
  baseURL: env.BACKEND_URL,
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`
  }
})


const TextEdit = (props) => {
  const [text, setText] = useState({ title: props.data.textTitle, content: props.data.textContent});

  const updateText = async (e) => {
    e.preventDefault();
    if(text.title && text.content){
      await authAxios.patch(`/texts/${props.data.textID}`, {textTitle: text.title, textContent: text.content})
      .then((res)=>{
        document.querySelector(".background-text-edit"+props.data.textID).classList.toggle("active");
        props.update();
        if(res.data==="success"){
          success("Saved Successfully!");
        }
        else{
          fail("An error occurred!");
        }
      })
      .catch((err)=>{
          fail("An error occurred!");
      });
    }
    else{
      alert("Enter all the fields!");
    }
  }

  return (
    <>
    <div className={"background-text-edit background-text-edit"+props.data.textID}>
         <Tilt
          className="tilt"
          tiltMaxAngleX={10}
          tiltMaxAngleY={10}
          perspective={1000}
          transitionSpeed={1000}
          scale={1}
          gyroscope={true}
          glareEnable={false}
        >
          <div id="textEditContainer">
              <button id="close" onClick={()=>{document.querySelector(".background-text-edit"+props.data.textID).classList.toggle("active")}}><img src={closeIcon} alt="close"></img></button>
              <form>
                  <div id="textTitleContainer">
                    <p>Add Title: </p>
                    <input placeholder="Add Title" type="text" id="title" onChange={(e)=>setText({...text, title: e.target.value})} value={text.title} required></input>
                  </div><br/>
                  <div id="addContentContainer">
                      <p>Add Text Body/Content: </p>
                      <textarea placeholder="Add Content" id="addContentTxt" onChange={(e)=>setText({...text, content: e.target.value})} value={text.content} required></textarea>
                  </div><br/>
                  <div id="uploadButton">
                      <button onClick={(e)=>updateText(e)}><img src={tickIcon} alt="tick"></img>Update</button>
                  </div>
              </form>
          </div>
        </Tilt>
    </div>
    </>
  )
}

export default TextEdit;